// update section config depending on featureModel and HousingType
import {setFeatureModel} from '../slices/configurationSlice';
import {setSectionConfig} from '../slices/statusSlice';
import {getFamilyConfig} from '../familyConfig';
import {startSpcSession} from '../slices/spcSlice';

export const sectionConfigMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'configuration/setProductModel') {
        // pick section config base on ProductModel
        const productModel = store.getState().configuration.data.projects[0].project.productModelId;
		const featureModelId = store.getState().configuration.data.projects[0].project.featureModelId;

		let model;
		if (productModel) {
			// console.log('sectionConfigMiddleware productData.models', productModel, store.getState().productData.models);
			model = store.getState().productData.models.find(m => m.productModelId === productModel);
			if (!model) {
				model = store.getState().productData.models.find(m => m.isDefault);
			}
			//console.log('sectionConfigMiddleware model', model);
		} else {
			console.log('sectionConfigMiddleware: no productModel');
		}
		if (model) {
			store.dispatch(startSpcSession({deploymentName: model.featureModelId, instance: 'default'}));
			store.dispatch(setFeatureModel({featureModel: model.featureModelId}));
		} else {
			console.log('sectionConfigMiddleware: no model');
		}
    }
    return result;
};
